// extracted by mini-css-extract-plugin
export default {"container":"viewSettings__container___tTgut","properties":"viewSettings__properties___uiEPJ","property":"viewSettings__property___QO4O1","search":"viewSettings__search___PO4Lx"};